namespace GeniuzPOS.PosShift {
    export namespace LookupRecieptforVatRefundService {
        export const baseUrl = 'PosShift/LookupRecieptforVatRefund';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LookupRecieptforVatRefundRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LookupRecieptforVatRefundRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "PosShift/LookupRecieptforVatRefund/Retrieve",
            List = "PosShift/LookupRecieptforVatRefund/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>LookupRecieptforVatRefundService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
